(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zentus-product-details"] && !Shopify.designMode) return;
  try {
    class ZentusProductDecoration extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.section?.addEventListener('variant:update', this.updateDecoration);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.updateDecoration);
    }

    updateDecoration = (event) => {
      const data = event.detail?.data;
      if (!data || String(data.productId) !== this.dataset.productId) return;
      const next = data.html?.getElementById(this.id);
      if (!next || !event.detail.resource) {
        this.hidden = true;
        return;
      }
      this.replaceChildren(...next.childNodes);
      this.hidden = next.hidden;
    };
  }

  if (!customElements.get('zentus-product-decoration')) {
    customElements.define('zentus-product-decoration', ZentusProductDecoration);
  }

  class ZentusProductMetafields extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section, dialog');
      this.section?.addEventListener('variant:update', this.updateInformation);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.updateInformation);
    }

    updateInformation = (event) => {
      const data = event.detail?.data;
      if (!data || String(data.productId) !== this.dataset.productId) return;
      const next = data.html?.getElementById(this.id);
      const list = this.querySelector('ul');
      const nextList = next?.querySelector('ul');
      const details = this.querySelector('details');
      if (!nextList || !list || !details) return;

      list.replaceChildren(...nextList.childNodes);
      if (!event.detail.resource) list.querySelector('[data-customs-code]')?.remove();
      details.hidden = !list.querySelector('li');
      this.dataset.productId = next.dataset.productId;
    };
  }

  if (!customElements.get('zentus-product-metafields')) {
    customElements.define('zentus-product-metafields', ZentusProductMetafields);
  }
  } catch(e) { console.error(e); }
})();

})();
